import "./certificados.scss";
import React, { useEffect, useState } from "react";
import TituloCard from "../../atoms/titles/Titulo";
import Button from "../../atoms/buttons/Button";
import Select from "react-select";
import { actualizarCertificados, getCertificadosConvocatoria } from "../../services/CertficadosLaboralesService";
import Confirm from "../../molecules/modals/Confirm";

const Certificados = (object) => {
  // const [convocatoriaSelect, setConvocatoriaSelect] = useState("");
  const [convocatorias, setConvocatoria] = useState([
    // { label: "TAS2006", value: "0" },
    // { label: "R1-2009", value: "1" },
    // { label: "T3/2007", value: "4" },
    // { label: "R1-2011", value: "5" },
    // { label: "R12011/2", value: "6" },
    // { label: "2011/TER", value: "2" },
  ]);

  const [convocatoriaSeleccionada, setConvocatoriaSeleccionada] = useState({})
  const [showConfirm, setShowConfirm] = useState(false);

  const handleShowConfirm = (dni) => {
    setShowConfirm(!showConfirm);
  };

  const handleCloseConfirm = (e) => {
    setShowConfirm(false);
  };

  const handleCambioCheckCertificado = (name, e) => {
    
    
    setConvocatoriaSeleccionada((prevState) => ({
      ...prevState,
      [name]: e ? "S" : "N",
    }))
  }

  const handleEnvioCambioCheck = (convocatoriaSeleccionada) => {
    
    actualizarCertificados(convocatoriaSeleccionada).then((data) => {
      
      getCertificadosConvocatoria().then((data) => {
        
        setConvocatoria(data.map((item) => {
          return {
            value: item.xcabpro,
            label: item.cconvocator,
            lcerlabant: item.lcerlabant,
            lcerlabfor: item.lcerlabfor,
          };
        }))
      })

      handleShowConfirm()
    })
  }

  useEffect(() => {
    getCertificadosConvocatoria().then((data) => {
      
      setConvocatoria(data.map((item) => {
        return {
          value: item.xcabpro,
          label: item.cconvocator,
          lcerlabant: item.lcerlabant,
          lcerlabfor: item.lcerlabfor,
        };
      }))
    })
  }, []);
  return (
    <>
      {/*<TituloCard
        tipo="tituloPagina2 noBg"
        titulo={"Visualización de los certificados"}
      />*/}
      <TituloCard tipo="tituloModal" titulo={<h2 className="tituloPagina4">Visualización de los certificados</h2>} />

      <div className="formulario container row">
        {/* <Formik
          initialValues={{
            convocatoria: "",
            checkPersonal: convocatoriaSeleccionada.certRegistroGeneralPersonal === "S",
            checkPublica: convocatoriaSeleccionada.certEscuelaAdmonPublica === "S",
          }}
          validate={(valores) => {
            const errores = {};
            if (valores.convocatoria == null || valores.convocatoria === "") {
              errores.convocatoria = "Por favor seleccione una convocatoria";
            }
            return errores;
          }}
          onSubmit={(valores) => {
            
          }}
        >
          {({ errors, values }) => (
            <>
              <Form>
                <div className="col-9 mx-auto">
                  <div className="col-12">
                    <>
                      <div className="row col-12 mt-4">
                        <label htmlFor="convocatoria">
                          Convocatoria <span className="rojo">*</span>:
                        </label>
                        <Field
                          as="select"
                          id="convocatoria"
                          name="convocatoria"
                          className="form-select"
                          onChange={(e) => {
                           
                            values.convocatoria =
                              convocatorias.find(
                                (convocatoria) => convocatoria.value == e.target.value
                              )
                            setConvocatoriaSeleccionadas(convocatorias.find(
                              (convocatoria) => convocatoria.value == e.target.value
                            ))
                          }}
                          defaultValue=""
                          value={undefined}
                        >
                          <option value={""} disabled>
                            Seleccione una opción
                          </option>
                          {convocatorias.map((convocatoria, i) => (
                            <option value={convocatoria.value} key={i}>
                              {convocatoria.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="convocatoria"
                          component={() => (
                            <div className="error rojo fs-4 pt-2">
                              {errors.convocatoria}
                            </div>
                          )}
                        />
                      </div>
                      <div className="row col-12 mt-3">
                        <div className="checkPersonal mt-2">
                          <Field
                            className="form-check-input"
                            type="checkbox"
                            name="checkPersonal"
                            id="checkPersonal"
                          // checked={convocatoriaSeleccionada?.certRegistroGeneralPersonal === "S"}
                          />{" "}
                          Certificado del Registro General de Personal.
                          <ErrorMessage
                            name="checkPersonal"
                            component={() => (
                              <div className="error rojo fs-4 pt-2">
                                {errors.checkPersonal}
                              </div>
                            )}
                          />
                        </div>
                      </div>
                      <div className="row col-12 ">
                        <div className="checkPublica mt-2">
                          <Field
                            className="form-check-input"
                            type="checkbox"
                            name="checkPublica"
                            id="checkPublica"
                          // checked={convocatoriaSeleccionada?.certEscuelaAdmonPublica === "S"}
                          />{" "}
                          Certificado de la Escuela de Admón. Pública.
                          <ErrorMessage
                            name="checkPublica"
                            component={() => (
                              <div className="error rojo fs-4 pt-2">
                                {errors.checkPublica}
                              </div>
                            )}
                          />
                        </div>
                      </div>
                      <div className="row col-12 mt-5">
                        <div className="d-flex justify-content-between">
                          <Button
                            id="consultaIRPF"
                            clases="btn-card"
                            nombre={
                              <>
                                Aceptar
                              </>
                            }
                            tipo="submit"
                          />
                          <Button
                            id="consultaIRPF"
                            clases="bg-danger rounded"
                            nombre={
                              <>
                                Cancelar
                              </>
                            }
                            tipo="submit"
                          />
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </Form>
            </>
          )}
        </Formik> */}

        <div className="row col-9 mt-4 mx-auto">
          <label htmlFor="convocatoria">
            Convocatoria <span className="rojo">*</span>:
          </label>
          <Select
            id="convocatoria"
            name="convocatoria"
            options={convocatorias}
            className="selectYear "
            onChange={(e) => {

              setConvocatoriaSeleccionada(convocatorias.find(
                (convocatoria) => convocatoria.value === e?.value
              ))
            }}
            placeholder={"Seleccione una opción"}
            // defaultValue={years[years.length - 1]}
            isClearable
          />
          {/* <ErrorMessage
            name="convocatoria"
            component={() => (
              <div className="error rojo fs-4 pt-2">
                {errors.convocatoria}
              </div>
            )}
          /> */}
        </div>
        <div className="row col-9 mt-3 mx-auto">
          <div className="checkPersonal mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              name="checkPersonal"
              id="checkPersonal"
              checked={convocatoriaSeleccionada?.lcerlabant === "S"}
              onChange={(e) => handleCambioCheckCertificado("lcerlabant", e.target.checked)}
            />{" "}
            Certificado del Registro General de Personal.
            {/* <ErrorMessage
                            name="checkPersonal"
                            component={() => (
                              <div className="error rojo fs-4 pt-2">
                                {errors.checkPersonal}
                              </div>
                            )}
                          /> */}
          </div>
        </div>
        <div className="row col-9 mx-auto">
          <div className="checkPublica mt-2">
            <input
              className="form-check-input"
              type="checkbox"
              name="checkPublica"
              id="checkPublica"
              checked={convocatoriaSeleccionada?.lcerlabfor === "S"}
              onChange={(e) => handleCambioCheckCertificado("lcerlabfor", e.target.checked)}
            />{" "}
            Certificado de la Escuela de Admón. Pública.
            {/* <ErrorMessage
                            name="checkPublica"
                            component={() => (
                              <div className="error rojo fs-4 pt-2">
                                {errors.checkPublica}
                              </div>
                            )}
                          /> */}
          </div>
        </div>
        <div className="row col-9 mt-5 mx-auto">
          <div className="d-flex justify-content-between">
            <Button
              id="consultaIRPF"
              clases="btn-card"
              nombre={
                <>
                  Aceptar
                </>
              }
              tipo="button"
              funcion={() => handleEnvioCambioCheck(convocatoriaSeleccionada)}
            />
            <Button
              id="consultaIRPF"
              clases="bg-danger rounded"
              nombre={
                <>
                  Cancelar
                </>
              }
              tipo="submit"
            />
          </div>
        </div>
        {showConfirm ? (
          <>
            <Confirm
              show={showConfirm}
              handleClose={handleCloseConfirm}
              titulo="Respuesta"
              mensaje="Certificado actualizado correctamente"
              respuesta={true}
            />
          </>
        ) : null}
      </div>
    </>
  );
};
export default Certificados;
